import { useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { apiClient } from '@cast/infrastructure-api';
import { EvictorConfig } from '@cast/types-workload-eviction';

const EVICTOR_CONFIG_QUERY_KEY = 'workload-eviction-config';

export const getEvictorConfigQueryKey = (params: Params) => {
  return [EVICTOR_CONFIG_QUERY_KEY, params];
};

type Params = {
  clusterId: string;
};

type UseEvictorConfigQueryArgs = {
  params: Params;
  options?: QueryOptions<EvictorConfig>;
};

export const useEvictorConfigQuery = ({
  params,
  options,
}: UseEvictorConfigQueryArgs) => {
  return useQuery({
    queryKey: getEvictorConfigQueryKey(params),
    queryFn: async () => {
      const { data } = await apiClient.workloadEviction.getConfig(params);
      return data;
    },
    ...options,
  });
};
